import styled from 'styled-components';

export const Script = styled.div`
  padding: 16px;
  border-radius: 16px;

  box-shadow: ${({ theme }) => theme.config.infoBlock.shadow};
`;
